export default "__VITE_ASSET__Bx1RZPxj__"